import React from 'react';
//import FlatButton from 'material-ui/FlatButton';
import HoverableSlider from './HoverableSlider';
import moment from 'moment';

class VideoStatus extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  handleMouseEnterOrMouseMove = (e) => {
    e.preventDefault(); // controlsが表示されなくなるのでcancelしない
    this.props.onOverlayFixed(true);
  };
  handleMouseLeave = (e) => {
    e.preventDefault(); // controlsが表示されなくなるのでcancelしない
    this.props.onOverlayFixed(false);
  };
  render = () => {
    const overlay = this.props.overlay;
    const service = this.props.service;
    const program = this.props.program;
    return (
      <div
        id="video-status"
        hidden={!overlay}
        style={{position: 'absolute', left: '0px', right: '0px', bottom: '0px', padding: '4px'}}
        onMouseEnter={this.handleMouseEnterOrMouseMove}
        onMouseMove={this.handleMouseEnterOrMouseMove}
        onMouseLeave={this.handleMouseLeave}
      >
        <LiveStatus
          videoType={this.props.videoType}
          currentDateTime={this.props.currentDateTime}
          service={service}
          program={program}
          onBackToLive={service => {this.setState({loading:false,program:undefined});this.props.onBackToLive(service);}}
          onPlayFromStart={this.props.onPlayFromStart}
          />
        <VideoSeekbar
          videoType={this.props.videoType}
          currentDateTime={this.props.currentDateTime}
          service={service}
          program={program}
          onBackToLive={service => {this.setState({loading:false,program:undefined});this.props.onBackToLive(service);}}
          onPlayFromPosition={this.props.onPlayFromPosition}
          onSeekPreview={this.props.onSeekPreview}
          />
      </div>
    );
  };
};
class LiveStatus extends React.Component {
  render = () => {
    var self = this;
    const titleStyle = {color:'white', display: 'inline-block'};
    if (this.props.videoType === 'live') {
      const backToStartBtnStyle = {
        color:'white',
        marginLeft: '0px',
        //backgroundColor:'rgba(0,0,0,0.3)',
        textDecoration: 'underline',
        fontWeight: 'bold',
        fontSize: 14,
        display:'inline-block',
        cursor:'pointer',
        zIndex: 2147483647
      };
      if (self.props.program === undefined) {
        backToStartBtnStyle['display'] = 'none'
      }
      return (
        <div
          style={{marginTop:'4px', fontSize:14}}
          id='live-status'
        >
          <div style={titleStyle}>{moment(this.props.currentDateTime).format('HH:mm:ss')}</div>
          <div
            className='live-label'
            style={{backgroundColor:'rgba(0,0,0,0)', padding:8, pointerEvents: 'none', display:'inline-block'}}
          >LIVE</div>
          <div
            style={backToStartBtnStyle}
            onClick={() => {self.props.onPlayFromStart(self.props.program)}}
            label=""
          >&lt;先頭から再生</div>
        </div>
      );
    }
    else {
      const backToLiveBtnStyle = {
        cursor:'pointer',
        display:'inline-block',
        color:'red',
        marginLeft: '0px',
        textDecoration: 'underline',
        fontWeight: 'bold',
        fontSize: 14,
        zIndex: 2147483647
      };
      return (
        <div
          id='timeshift-status'
          style={{marginTop:'4px', fontSize:14}}
          >
          <div style={titleStyle}>{moment(this.props.currentDateTime).format('HH:mm:ss')}</div>
          <div
            className='timeshift-label'
            style={{backgroundColor:'rgba(0,0,0,0)',padding:8,color:'#fefefe', pointerEvents: 'none', display:'inline-block'}}
            label=""
          >見逃し視聴中</div>
          <div
            //backgroundColor="rgba(0, 0, 0, 0.3)"
            style={backToLiveBtnStyle}
            onClick={() => {self.props.onBackToLive(self.props.service)}}
            label=""
          >ライブに戻る&gt;</div>
        </div>
      );
    }
  };
}
class VideoSeekbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showPreview: false,
      previewTime: '',
      previewPosition: 0, // 0~100
      isPreviewFuture: false
    };
  }
  // called after onSeekbarDragEnd
  onSeekbarChanged = (value) => {
    console.log('onSeekbarChanged');

    this.seekPosition = value;
    let program = this.props.program
    let now = moment()
    let startTime = program ? moment(program.start_time * 1000) : moment()
    let endTime = program ? moment(program.end_time * 1000) : moment()
    let duration = endTime.diff(startTime)
    let position = duration * this.seekPosition / 1000
    let selectedTime = startTime.add(position)

    if (selectedTime.diff(now) > 0) {
      // 現在時刻より未来を選択したらライブに戻る
      if (this.props.videoType !== 'live') {
        this.props.onBackToLive(this.props.service)
      }
    } else {
      this.props.onPlayFromPosition(program, this.props.service, position / 1000)
    }
  }
  onSeekbarDragEnd = () => {
    console.log('onSeekbarDragEnd');
  }
  onClick = () => {
    console.log('click');
    this.onSeekbarChanged(this.hoverPosition);
  }
  onHoverChange = (value) => {
    console.log('onHoverChange');
    this.hoverPosition = value;
    let program = this.props.program
    let now = moment()
    let startTime = program ? moment(program.start_time * 1000) : moment()
    let endTime = program ? moment(program.end_time * 1000) : moment()
    let duration = endTime.diff(startTime)
    let position = duration * value / 1000
    let selectedTime = startTime.add(position)
    let isPreviewFuture = selectedTime.diff(now) > 0

    this.setState({
      previewTime: selectedTime.format('HH:mm:ss'),
      previewPosition: value / 10,
      isPreviewFuture: isPreviewFuture
    });
    if (!isPreviewFuture) {
      const preview = document.getElementById('preview');
      preview.currentTime = position / 1000;
    }
  }
  render = () => {
    let program = this.props.program
    let isSeekDisabled = (program === undefined)
    let currentTime = this.props.currentDateTime ? moment(this.props.currentDateTime) : moment()
    let startTime = program ? moment(program.start_time * 1000) : moment()
    let endTime = program ? moment(program.end_time * 1000) : moment()
    let currentTimeRatio = currentTime.diff(startTime) / endTime.diff(startTime)
    return (
      <div id='video-seekbar' style={{ fontSize:14, color:'#fefefe' }}>
        <div>{startTime.format('HH:mm')}</div>
        <div className="seekbar">
          <div
            id="preview-area"
            hidden={!this.state.showPreview}
            style={{ left: this.state.previewPosition + '%' }}
            >
            <div id="preview-background">
              <video id="preview" hidden={this.state.isPreviewFuture} />
            </div>
            <div id="preview-time">
              {this.state.previewTime}
            </div>
          </div>
          <HoverableSlider
            className="seekbar"
            value={currentTimeRatio * 1000}
            max={1000}
            min={0}
            disabled={isSeekDisabled}
            onChange={(e, value) => { this.onSeekbarChanged(value); }}
            onDragEnd={this.onSeekbarDragEnd}
            onClick={this.onClick}
            onHoverChange={(e, value) => { this.onHoverChange(value); }}
            onHoverStart={_ => { this.setState({showPreview: true}); }}
            onHoverEnd={_ => { this.setState({showPreview: false}); }}
            />
        </div>
        <div>{endTime.format('HH:mm')}</div>
      </div>
    )
  }
}
export default VideoStatus;



// WEBPACK FOOTER //
// ./src/components/VideoStatus.js